import { render } from "./ImportButton.vue?vue&type=template&id=a6d1b154&scoped=true"
import script from "./ImportButton.vue?vue&type=script&lang=js"
export * from "./ImportButton.vue?vue&type=script&lang=js"

import "./ImportButton.vue?vue&type=style&index=0&id=a6d1b154&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d1b154"]])

export default __exports__